import { render, staticRenderFns } from "./ConfirmClearData.vue?vue&type=template&id=168a427a&"
import script from "./ConfirmClearData.vue?vue&type=script&lang=js&"
export * from "./ConfirmClearData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports